import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import AnonymousPage from "../anonymous-pages/anonymous-page";
import BoxWraper from "../box-wrapper";
import Errors from "../../shared/errors";
import SmallLoader from "../../shared/small-loader/small-loader";

function PaymentComplete(props) {

  const { errors, paid } = props;
  const [showDelayedMessage, setShowDelayedMessage] = useState(false);

  useEffect(() => {
    if (!paid) {
      const timer = setTimeout(() => {
        setShowDelayedMessage(true);
      }, 60000); // 60 seconds = 1 minute

      return () => clearTimeout(timer);
    }
  }, [paid]);

  return (
    <AnonymousPage>
      <BoxWraper width={5}>
        <Errors errors={errors} />
        <p>Thank you for your payment. You will shortly receive an email confirming your payment.</p>
        {!paid && <div><p>This page will update once your payment is confirmed.</p>
          <SmallLoader />
          {showDelayedMessage && (
            <p className="notification is-warning mt-2">
              This seems to be taking a long time. Try refreshing the page.
            </p>
          )}
        </div>}
        {paid && <p>Your account is now active and you can continue to your <Link to={'/films'}>films</Link>.</p>}
      </BoxWraper>
    </AnonymousPage>
  );
}

export default PaymentComplete;
